export default __webpack_public_path__ + "static/media/purchaseconfirmation.50541df7.png";